export async function getAllPermissions(currentPermissions) {
	var permissions = {
		notification: 0,
		bluetooth: 0,
		location_wheninuse: 0,
		location_always: 0,
		motion: 0,
	}

	const permissionTypes = Object.keys(currentPermissions)
	await Promise.all(
		permissionTypes.map(async (permissionType) => {
			const status = await checkPermission(permissionType)
			permissions[permissionType] = status
		}),
	)

	console.warn('getAllPermissions', permissions)
	return permissions
}

export async function checkPermission(permissionType) {
	var status = 0
	var permission = await kettle.checkPermission(permissionType)
	if (permission != 'default' && permission != 'not_determined') {
		status = permission === 'granted' ? 1 : -1
	}
	if (permissionType == 'location_always' && status == -1) {
		const hasRequested = await kettle.get(permissionType + '_requested')
		if (!hasRequested || hasRequested == null) status = 0
	}
	return status
}

export async function requestPermission(permissionType) {
	var permission = await kettle.requestPermission(permissionType)
	kettle.set(permissionType + '_requested', 'true')
	if (permission != 'default' && permission != 'not_determined') {
		return permission === 'granted' ? 1 : -1
	}
	return 0
}
